import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/app/environments/environment';

@Injectable({ providedIn: 'root' })
export class LogsService {
    private baseUrl = environment.apiUrl;
    private httpClient = inject(HttpClient);

    registerSessionClose(clientSessionId: string, usuario: string): Observable<unknown> {
        return this.httpClient.post(`${this.baseUrl}/api/v1/logs-general/logs/`, {
            client_session_id: clientSessionId,
            usuario,
            accion: 'cierre_sesion',
            app_name: 'conectados',
            tipo_acceso: 'web',
            mensaje: 'cierre sesion',
        });
    }
}
